export default "__VITE_ASSET__DvI4iv05__"